module.exports = __webpack_public_path__ + "img/reject-payment.0fdb17de.svg";